export enum ROLE_CODES {
    LOYYAL_ADMIN = 'LOYYAL_ADMIN',
    PROGRAM_ADMIN = 'PROGRAM_ADMIN',
    MERCHANT_ADMIN = 'MERCHANT_ADMIN'
}